import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adminapp-asset-discovery-wrapper',
  templateUrl: './asset-discovery-wrapper.component.html',
  styleUrls: ['./asset-discovery-wrapper.component.scss']
})
export class AssetDiscoveryWrapperComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
